// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetGameFollowBody = {
  eventId: string;
  isFollowing: boolean;
};

export type typeNotificationSettingsSetGameFollowOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { eventId: string; isFollowing: boolean };
};

export type typeNotificationSettingsSetGameFollowOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetGameFollowOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetGameFollowOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetGameFollowBody = {
  type: "object",
  properties: {
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    isFollowing: { type: "boolean" },
  },
  required: ["eventId", "isFollowing"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetGameFollow(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsSetGameFollowBody,
    );
  }

  return async function postNotificationSettingsSetGameFollow(
    payload: typeNotificationSettingsSetGameFollowBody,
  ): Promise<
    | typeNotificationSettingsSetGameFollowOutput200
    | typeNotificationSettingsSetGameFollowOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetGameFollow" failed before calling the network. #d41e67afa2a5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d41e67afa2a5" },
        },
        data: null,
      } as typeNotificationSettingsSetGameFollowOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-game-follow`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetGameFollowOutput200
      | typeNotificationSettingsSetGameFollowOutput400;
  };
}
